//data reducer
export const SET_JSON = "SET_JSON";
export const SET_LOADED = "SET_LOADED";
export const SET_ERROR = "SET_ERROR";

//layout reducer
export const SET_NUM_GRID_COLUMNS = "SET_NUM_GRID_COLUMNS";
